// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__22Zvj","active":"styles_active__3iKeI"};